module.exports = __webpack_public_path__ + "img/programok1.037e9c12.png";